import { componentHasAnimations, filterAnimatedComponents, Pin, PinComponent } from '@lessonup/pins-shared';

/**
 * Calculates the animation order number for a pin component.
 *
 * Returns the 1-based position (1, 2, 3, ...) of the component in the sorted list
 * of all animated components in the pin, or null if:
 * - The component does not have animations
 * - The component is not found in the pin's component list
 *
 * Components are sorted by animation entry order first, then by id for consistent ordering.
 *
 * @param pin - The pin containing all pin components
 * @param pinComponent - The component to get the animation order for
 * @returns The animation order number (1-based) or null if not applicable
 */
export function getAnimationOrder(pin: Pin, pinComponent: PinComponent): number | null {
  if (!componentHasAnimations(pinComponent)) {
    return null;
  }

  const orderedComponents = filterAnimatedComponents(pin.pinComponents);
  const index = orderedComponents.findIndex((c) => c.id === pinComponent.id);

  if (index === -1) {
    return null;
  }

  return index + 1;
}
